import { useParams } from 'react-router-dom';
import { useGetAssetLogsQuery, useGetAssetByIdQuery } from '@/services';
import AuditHistory from '@/components/AuditHistory';

export default function AssetHistory() {
    const { assetId, id: amcId } = useParams<{ assetId: string; id: string }>();
    const { data: asset } = useGetAssetByIdQuery(assetId!, { skip: !assetId });
    const { data, isLoading, error } = useGetAssetLogsQuery(assetId!, { skip: !assetId });

    return (
        <AuditHistory
            title="History"
            entityName={asset?.name}
            backLink={amcId ? {
                to: `/amcs/${amcId}/assets`,
                label: 'Back to Asset'
            } : undefined}
            data={data}
            isLoading={isLoading}
            error={error}
            emptyMessage="No asset history found."
        />
    );
}
